import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ZipExportIcon = (props: IconProps) => (
  <Icon w="54px" h="54px" viewBox="0 0 54 54" {...props}>
    <path d="M45 13.5H27L22.5 9H9c-2.475 0-4.4775 2.025-4.4775 4.5L4.5 40.5C4.5 42.975 6.525 45 9 45h36c2.475 0 4.5-2.025 4.5-4.5V18c0-2.475-2.025-4.5-4.5-4.5ZM36 36h4.5v-4.5H36V27h4.5v-4.5H36V18h9v22.5h-9V36Zm0 0h-4.5v4.5H9v-27h11.6325l4.5 4.5H31.5v4.5H36V27h-4.5v4.5H36V36Z" />
  </Icon>
);

export default memo(ZipExportIcon);
